//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { Avatar, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import changeColor from '../views/themeColor/changeColor.vue'

Vue.use(Avatar).use(Dropdown).use(DropdownMenu).use(DropdownItem)
export default {
    props: {
        topMenus: Array,
        userInfo: Object,
        curIndex: Number
    },
    data() {
        return {}
    },
    methods: {
        clickMenu(index) {
            this.$store.dispatch('setTopMenuIndex', index)
            var topMenu = this.topMenus[index]
            if (!topMenu.children || topMenu.children.length === 0) {
                if (this.$route.path !== topMenu.url)
                    this.$router.push(topMenu.url)
            }
        },
        logOut() {
            location.href = 'login.html'
        }
    },
    components: { changeColor }
}
